<div style="width:100%;height:175px;background-color:#9ad59a;">
    <div style="height:30px;margin-top:40px;">
        <span class="d-flex justify-content-center align-items-center">
            <span class="ace-secondary-text-14pt-semi" style="font-size:36px;font-weight: bold !important;color: white;">{{successMessage}}</span>
        </span>
    </div>


    <div style="margin-top:25px;margin-bottom:20px;">
        <span class="d-flex justify-content-center align-items-center">
        <span class="ace-secondary-text-14pt-semi" style="font-size:21px;font-weight: bold !important;color: white;">
            <button mat-button mat-dialog-close cdkFocusInitial style="background-color:white;color:black;">Close</button>&nbsp;&nbsp;
        </span>
        </span>
    </div>

</div>
